import React from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import MobileBanner from "./MobileBanner";
import MobileItems from "./MobileItem";

const Mobile = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <MobileBanner />
      <MobileItems />
      <FooterThree />
    </>
  );
};

export default Mobile;
